export function getBankCssClass(logo) {
    const logoMatch = logo.match(/logo-large-(\w+)/);
    const bankName = logoMatch ? logoMatch[1] : '';
    
    const logoMap = {
        'banorte': 'icon-brand-banorte-card',
        'bbva': 'icon-brand-bbva-card',
        'santander': 'icon-brand-santander-card',
        'invex': 'icon-brand-invex-card',
        'hsbc': 'icon-brand-hsbc-card',
        'banamex': 'icon-brand-banamex-card',
        'scotiabank': 'icon-brand-scotia-card',
        'scotia': 'icon-brand-scotia-card',
        'inbursa': 'icon-brand-inbursa-card'
    };
    
    return logoMap[bankName] || 'icon-brand-default';
}

export function processBankInformation(bankAccountInformation) {
    if (!bankAccountInformation || !Array.isArray(bankAccountInformation)) {
        return [];
    }
    
    return bankAccountInformation.map(bank => {
        return {
            logo: bank.logo,
            bankTitle: bank.bankTitle,
            bankInfo: bank.bankInfo,
            cssClass: getBankCssClass(bank.logo)
        };
    });
}

export function getDepositBanks(data) {
    const bankInfo = data.depositInfo?.extraInformation?.bankAccountInformation;
    return processBankInformation(bankInfo);
}
